export const CHANGE_COURIER_SLOT = Symbol('CHANGE_COURIER_SLOT');
export const CHANGE_COURIER_SLOT_REQUEST = Symbol('CHANGE_COURIER_SLOT_REQUEST');
export const CHANGE_COURIER_SLOT_SUCCESS = Symbol('CHANGE_COURIER_SLOT_SUCCESS');
export const CHANGE_COURIER_SLOT_ERROR = Symbol('CHANGE_COURIER_SLOT_ERROR');